<template>
    <!-- TODO: Turn this into a simpler template with a v-for -->
    <b-form>
        <b-form-group
            horizontal
            label="Email"
            label-for="email"
            label-cols="0"
            label-cols-sm="2"
            label-align-sm="right"
        >
            <b-form-input
                id="email"
                type="email"
                :value="email"
                @input.native="emitUpdate"
                @blur.native="emitOnBlur"
            />
        </b-form-group>

        <b-form-group
            horizontal
            label="First Name"
            label-for="fname"
            label-cols="0"
            label-cols-sm="2"
            label-align-sm="right"
        >
            <b-form-input
                id="fname"
                type="text"
                :value="fname"
                @input.native="emitUpdate"
            />
        </b-form-group>

        <b-form-group
            horizontal
            label="Last Name"
            label-for="lname"
            label-cols="0"
            label-cols-sm="2"
            label-align-sm="right"
        >
            <b-form-input id="lname"
                          type="text"
                          :value="lname"
                          @input.native="emitUpdate"
            />
        </b-form-group>

        <b-form-group
            horizontal
            label="Phone"
            label-for="phone"
            label-cols="0"
            label-cols-sm="2"
            label-align-sm="right"
        >
            <b-form-input id="phone"
                          type="tel"
                          :value="phone"
                          @input.native="emitUpdate"
            />
        </b-form-group>
    </b-form>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        email: { type: String, default: null },
        fname: { type: String, default: null },
        lname: { type: String, default: null },
        phone: { type: String, default: null },
    },

    data() {
        return { listeners: this.$listeners };
    },

    methods: {
        emitUpdate($event) {
            this.$emit(`update:${$event.target.id}`, $event.target.value);
        },

        emitOnBlur($event) {
            this.$emit(`blur:${$event.target.id}`, $event.target.value);
        },
    },
};
</script>
